import instructionImg1 from "../../../images/inst1.png";
import instructionImg2 from "../../../images/inst2.png";
import instructionImg3 from "../../../images/inst3.png";

const instructioncontentSsc = {
  en: `<img src="${instructionImg1}"  alt="Instructions" /></p><p><img src="${instructionImg2}"  alt="Instructions" /></p><p><img src="${instructionImg3}"  alt="Instructions" /></p>`,
};
export default instructioncontentSsc; 